import { render, staticRenderFns } from "./FeedbackCreate.vue?vue&type=template&id=76ab7c0b&"
import script from "./FeedbackCreate.vue?vue&type=script&lang=js&"
export * from "./FeedbackCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports